<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { ForgotPasswordForm } from '~/components/feature/auth'

const { t } = useI18n()
const breadcrumbs = [{ title: t('page.password_reset.breadcrumb'), url: '/password/reset' }]
const router = useRouter()

// Redirect already authenticated users
const { isLoggedIn, initializeAuth } = useUser()
const { getPathWithLocale } = useLocalizedPath()

// Initialize auth first, then check login status
await initializeAuth()

if (isLoggedIn.value) {
  await router.push(getPathWithLocale('/'))
}
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <div class="flex min-h-[600px] items-center justify-center py-8">
        <div class="mx-auto w-full max-w-xl">
          <div class="space-y-5 rounded-2xl bg-white p-8 shadow-xl">
            <div class="space-y-2 text-center">
              <Heading tag="h1" class="AuthHeading">
                {{ $t('page.password_reset.heading') }}
              </Heading>
              <p class="text-gray-600">{{ $t('page.password_reset.description') }}</p>
            </div>

            <ForgotPasswordForm />

            <div class="pt-4 text-center">
              <p class="text-sm text-gray-600">
                {{ $t('page.password_reset.remembered') }}
                <NuxtLinkLocale
                  to="/login"
                  class="font-semibold text-blue-600 transition-colors hover:text-blue-700"
                >
                  {{ $t('page.password_reset.login') }}
                </NuxtLinkLocale>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </Main>
</template>
